import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6cbbdb0a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbbdb0a')) {
      api.createRecord('6cbbdb0a', component.options)
    } else {
      api.reload('6cbbdb0a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6cbbdb0a&", function () {
      api.rerender('6cbbdb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4Ge0Wfex2jxde/JS/comp/openstreetmap.vue"
export default component.exports